import TYPES from './types';
import AUTH_TYPES from 'store/auth/types';

import { items } from 'components/layouts/sidebar/panel/menu/_constants';

const INITIAL_STATE = {
  isPanelOpen: false,
  activePanel: null,
  menu: {
    collapsed: false,
    items
  }
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TYPES.TOGGLE_PANEL:
      const isPanelOpen =
        payload && payload !== state.activePanel && state.isPanelOpen ? true : !state.isPanelOpen;

      return {
        ...state,
        isPanelOpen,
        activePanel: !isPanelOpen ? null : payload
      };

    case TYPES.COLLAPSE_MENU:
      return {
        ...state,
        menu: {
          ...state.menu,
          collapsed: !state.menu.collapsed
        }
      };

    case AUTH_TYPES.LOGOUT_CLEANUP:
      return {
        ...state,
        isPanelOpen: false,
        activePanel: null
      };

    default:
      return state;
  }
};

export default reducer;
